export default "__VITE_ASSET__45abffe1__"